<template>
  <div class="topnav">
    <div
      id="menuHamburger"
      :style="{ 'background-color': accentColor }"
      v-on:click="toggleMenuHamburger"
    >
      <i class="fa fa-bars fa-1x"></i>
    </div>
    <div id="menuFranchise" :style="{ 'background-color': accentColor }">
      <router-link v-if="$route.name != 'Pay'" to="/menu">{{
        franchiseName
      }}</router-link>
      <div v-else class="action">{{ franchiseName }}</div>
    </div>
    <app-cartMenu
      v-if="$route.name != 'Pay'"
      ref="cartMenuPartial"
    ></app-cartMenu>
    <div id="ordersMenu">
      <router-link to="/menu">
        <span>Menu</span>
      </router-link>
      <router-link v-if="$isLoggedIn" to="/profile">
        <span>Profile</span>
      </router-link>
      <router-link v-if="$isLoggedIn" to="/history">
        <span>Orders</span>
      </router-link>
      <router-link to="/cart">
        <span>Cart</span>
      </router-link>
      <router-link to="/explore">
        <span>Explore</span>
      </router-link>
      <div v-if="$isLoggedIn" class="action" v-on:click="logout">
        <span>Logout</span>
      </div>
      <router-link v-if="!$isLoggedIn" to="/login">
        <span>Login</span>
      </router-link>
      <router-link to="/qrcscanner">
        <span>QRC Scanner</span>
      </router-link>
      <div v-if="$payInvNo" class="action" v-on:click="pay">
        <span>SnapŉPay</span>
      </div>
    </div>
  </div>
</template>
<script>
import CartMenuPartial from '@/components/CartMenuPartial.vue';

export default {
  components: {
    'app-cartMenu': CartMenuPartial,
  },
  data() {
    return {
      pageName: this.$route.name,
    };
  },
  computed: {
    accentColor: function() {
      return this.$franchiseAccentColor;
    },
    franchiseName: function() {
      if (this.$franchiseName) return this.$franchiseName;
      else return 'SnapnTab';
    },
  },
  methods: {
    toggleMenuHamburger() {
      var nav = document.getElementById('ordersMenu');
      if (nav.style.display == 'block') nav.style.display = 'none';
      else nav.style.display = 'block';
    },
    logout() {
      this.logoutUser();
    },
    pay() {
      var _self = this;
      if (this.$route.name != 'Pay')
        _self.$router.push({
          path: 'Pay',
          query: {
            fid: _self.$payFID,
            bid: _self.$payBID,
            invNo: _self.$payInvNo,
          },
        });
    },
  },
  created() {},
  mounted() {
    document.addEventListener('click', function(e) {
      var ordersMenu = document.getElementById('ordersMenu');
      if (
        e.target.id != 'menuHamburger' &&
        e.target.parentElement.id != 'menuHamburger' &&
        ordersMenu != null &&
        ordersMenu.style.display == 'block'
      ) {
        ordersMenu.style.display = 'none';
      }

      var cartItemsContainer = document.getElementById('cartItemsContainer');
      if (
        e.target.id != 'menuCart' &&
        e.target.parentElement.id != 'menuCart' &&
        cartItemsContainer != null &&
        cartItemsContainer.style.display == 'block'
      ) {
        cartItemsContainer.style.display = 'none';
      }
    });
  },
};
</script>
<!-- Styles -->
<style>
#main-nav-bar {
  background-color: #444444 !important;
}

#main-nav-bar > div {
  width: 33%;
  text-align: center;
}

#main-nav-bar > div:first-child {
  text-align: left;
}

#main-nav-bar > div:last-child {
  text-align: right;
}
/* HAMBURGER MENU */
.topnav {
  background-color: #000;
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 2;
  height: 52px;
}

.topnav #ordersMenu {
  display: none;
  position: fixed;
  top: 52px;
  background-color: #333333;
  width: 100%;
}

.topnav #ordersMenu a,
.topnav #ordersMenu div.action {
  height: 52px;
  line-height: 52px;
  color: white;
  text-decoration: none;
  font-size: 17px;
  display: block;
  text-align: center;
}

.topnav #myLinks {
  display: none;
}

.topnav #menuFranchise {
  height: 52px;
  line-height: 52px;
  color: white;
  text-decoration: none;
  font-size: 17px;
  display: block;
  text-align: center;
}

.topnav #menuFranchise a {
  color: white;
  height: 100%;
}

.topnav #menuHamburger {
  position: fixed;
  width: 52px;
  text-align: center;
  line-height: 52px;
  color: white;
  z-index: 100;
  cursor: pointer;
}

.topnav #menuFranchise {
  color: white;
}

.topnav #menuFranchise a {
  margin: auto;
}

.topnav #menuCart {
  position: fixed;
  top: 0;
  right: 0;
  width: 110px;
  text-align: center;
  line-height: 52px;
  color: white;
  z-index: 100;
  cursor: pointer;
}

.topnav #menuCart label {
  font-weight: unset;
}

.topnav #menuCart .badge {
  background-color: #c30000;
  font-size: 10px;
  position: absolute;
  top: 8px;
  right: 7px;
  padding: 1px;
  padding-left: 3px;
  padding-right: 4px;
  border-radius: 10px;
}

.topnav div#ordersMenu {
  z-index: 100;
}
</style>
